export default __webpack_public_path__ + "static/media/metamask.31b75dcc.svg";